import * as React from "react"

import { cn } from "@/lib/utils"

export function PageTitle({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h1 className={cn("text-3xl font-bold text-gray-900", className)} {...props} />
  )
}

export function PageSubtitle({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn("text-gray-500", className)} {...props} />
}

export function MutedText({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn("text-xs text-gray-400", className)} {...props} />
}
